<div class="mts-4 mxs-3 flex-column gap-20px">
    <app-supply-list [isCollapsed]="this.isCollapsed"
        *ngIf="!this.isCollapsed || (this.isCollapsed && this.isBilling)"></app-supply-list>

    <mat-divider [inset]="true" *ngIf="!this.isCollapsed"></mat-divider>

    <app-order-list [case]="this.case" [isCollapsed]="this.isCollapsed"
        *ngIf="!this.isCollapsed || (this.isCollapsed && !this.isBilling)"></app-order-list>
</div>
